<template lang="pug">
  div
    v-overlay(:value="isLoading")
      v-progress-circular(:value="20" indeterminate)
    v-form.fill-height(
      ref='form',
      :class="formWrapperClass",
      v-if="!isLoading",
      v-model='valid',
      lazy-validation,
    )
      slot(
        :model="model",
        :reset="reset",
        :validate="validate",
        :valid="valid",
      )
</template>

<script>
import { clone } from 'ramda';
import * as models from '@/constant/forms';
import { progressWrapper } from '@/config/mixins';

export default {
  props: {
    type: {
      type: String,
      requried: true,
    },

    noSpacing: {
      type: Boolean,
      default: false,
    },

    formClass: {
      type: Array,
      default: () => [],
    },
  },

  mixins: [progressWrapper],

  data: () => ({
    valid: true,
  }),

  computed: {
    formWrapperClass() {
      return this.formClass.length != 0 ? this.formClass : ['pa-5'];
    },
  },

  created() {
    if (this.$route.meta.action) {
      this.wrapProgress(() =>
        this.$store
          .dispatch(this.$route.meta.action, this.$route.params.id)
          .then(data => (this.model = data))
          .catch(() => this.$router.push({ name: 'dashboard' })),
      );
    } else {
      this.model = clone(models[this.type]);
    }
  },

  methods: {
    validate() {
      return this.$refs.form.validate();
    },

    reset() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>
